export default __webpack_public_path__ + "f2b7d8226225b45e9376d4b1b0196aa9.svg";